module.exports = __webpack_public_path__ + "img/logo.7f78f279.png";